import { icons } from "./icons";
import image1 from '../assets/service1.png'
import image2 from '../assets/service2.png'
import image3 from '../assets/service3.png'

export const control = [
  {
    image: image1,
    name : 'Oil Level',
    text1 : 'Engine',
    text2 : 'Don’t Replace',
    icon: icons.serviceCont1
  },
  {
    image: image2,
    name : 'Brake Pads',
    text1 : 'Wheels',
    text2 : 'Still Good',
    icon: icons.serviceCont2
  },
  {
    image: image3,
    name : 'Steering',
    text1 : 'Drivetrain',
    text2 : 'Need Change',
    icon: icons.serviceCont3
  },
  {
    image: image1,
    name : 'Oil Level',
    text1 : 'Engine',
    text2 : 'Don’t Replace',
    icon: icons.serviceCont4
  },
]
